import CitySEOHead from "@/components/feature/CitySEOHead";
import SanFranciscoHeroSection from "./components/HeroSection";
import CityStickyNav from "@/pages/city-template/components/CityStickyNav";
import CityProcessingTimeSection from "@/pages/city-template/components/CityProcessingTimeSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityFAQSection from "@/pages/city-template/components/CityFAQSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { sanFranciscoConfig as c } from "./data";

export default function SanFranciscoPage() {
  return (
    <>
      <CitySEOHead
        city={c.city}
        state={c.state}
        stateAbbr={c.stateAbbr}
        route={c.route}
        title={c.title}
        description={c.metaDescription}
        geoPlacename={c.geoPlacename}
        geoPosition={c.geoPosition}
        faqs={c.faqs}
        servicesSchema={c.servicesSchema}
        statePageName={c.statePageName}
        statePageRoute={c.statePageRoute}
        hasPhysicalOffice
        lastModified={c.lastModified}
        keywords={c.keywords}
        ogImage={c.heroImageUrl}
        areaServedList={c.areaServedList}
        serviceAreaDesc={c.serviceAreaDesc}
      />

      <div className="font-sans">
        <SanFranciscoHeroSection />
        <CityStickyNav links={c.stickyNavLinks} />
        <CityProcessingTimeSection
          city={c.city}
          state={c.stateAbbr}
          options={c.processingOptions}
          intro={c.processingIntro}
          regionalAgency={c.regionalAgency}
        />
        <CityLocalAreaSection
          city={c.city}
          state={c.state}
          cities={c.nearbyCitiesZips}
          benefits={c.benefits}
          internalLinks={c.internalLinks}
          officeNote={c.fpcOfficeNote}
          officeDistance={c.fpcOfficeDistance}
          officeAddress={c.fpcOfficeAddress}
          serviceAreaIntro={c.serviceAreaIntro}
          nearbyCitiesIntro={c.nearbyCitiesIntro}
          localAreaIntro={c.localAreaIntro}
          mapEmbedUrl={c.mapEmbedUrl}
          officePhone={c.officePhone}
          officeHours={c.officeHours}
          officePhotoUrl={c.officePhotoUrl}
          officePhotoAlt={c.officePhotoAlt}
          landmarks={c.landmarks}
          exploreNearbyHeading={c.exploreNearbyHeading}
        />
        <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
        <CityTestimonialsSection
          city={c.city}
          testimonials={c.testimonials.slice(0, 3)}
          intro={c.testimonialsIntro}
        />
        <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
        <CityComparisonSection
          city={c.city}
          regionalAgency={c.regionalAgency}
          rows={c.comparisonRows}
          extraColumns={c.comparisonExtraColumns}
        />
        <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
        <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
        <CityFAQSection city={c.city} faqs={c.faqs} intro={c.faqIntro} />
        {c.travelTiming && (
          <CityTravelTimingSection city={c.city} data={c.travelTiming} />
        )}
        {c.destinations && (
          <CityDestinationsSection city={c.city} data={c.destinations} />
        )}
        <CityHelpfulResourcesSection
          city={c.city}
          state={c.state}
          photoLocations={c.photoLocations}
          dmvLocations={c.dmvLocations}
          airports={c.airports}
          dmvWebsite={c.dmvWebsite}
          dmvLabel={c.dmvLabel}
          vitalRecordsLinks={c.vitalRecordsLinks}
        />
        <SEOCrossLinks currentRoute={c.route} state={c.stateAbbr} showCities={true} />
        <CityFinalCTA />
      </div>
    </>
  );
}